import "./events.css";
import "../home/home.css";
import EventTiles from "../../../components/page/event/event-tile/event.tile.component";
import { public_event_list } from "../public.api";

import React, { useEffect, useState } from "react";
import Loader from "../../../components/loader/loader";
import BreadCrumbsComp from "../../../components/navigator/breadcrumbs";
import moment from "moment";

export default function Events(props) {
  const [data, setData] = useState([]);
  const [url, setUrl] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6);
  let fromHome = sessionStorage.getItem("continueFrom");
   const lang = props.state?.language || "en";
   //console.log(lang)
  const fetchEvents = () => {
    public_event_list().then((res) => {
      const today = moment(); 
      const upcomingEvents = res.data.filter((event) => {
        const eventDateStr = event.en?.eventDate || event.ma?.eventDate;
        const eventDate = moment(eventDateStr, "DD-MM-YYYY");
        return eventDate.isSameOrAfter(today, "day");
      });

      setData(upcomingEvents);
      setCurrentPage(1);
      setUrl(res.current_url);
      setIsActive(false);
    });
  };
  useEffect(() => {
    fetchEvents();
  }, []);

  const totalItems = data.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      {fromHome === "events" && <BreadCrumbsComp section="home" />}
      <div>
        <Loader open={isActive} />
        <div>
          {/* ======================= Events  =================================================================== */}
          <div className="">
            <div
              className={
                fromHome === "events"
                  ? "header-banner-from-home "
                  : "header-banner"
              }
            >
              <div className="tit-txt">
                {props.state.language === "ma"
                  ? "വരാനിരിക്കുന്ന പരിപാടികൾ"
                  : "Upcoming Events "}
              </div>
            </div>
          </div>
          <div className="events-section">
            <div className="event-tile-container">
              {currentItems?.length > 0 ? (
                currentItems.map((item) => (
                  <EventTiles
                    key={item.id}
                    {...props}
                    data={item}
                    url={url}
                    isBookable={true}
                  />
                ))
              ) : (
                <div className="event-empty-state">
                  {props.state.language === "ma"
                    ? "പരിപാടികളൊന്നും ലഭ്യമല്ല"
                    : "No upcoming events right now. Please check back soon."}
                </div>
              )}
            </div>

            {totalPages > 1 && (
              <div className="d-flex justify-content-between align-items-center mt-4 px-4 w-100 flex-wrap pagination-container" style={{ gap: '15px', maxWidth: '1200px', margin: '20px auto 0 auto' }}>
                <div className="text-muted" style={{ fontSize: "14px" }}>
                  {props.state.language === "ma" ? (
                    <>കാണിക്കുന്നത് <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> (ആകെ <b>{totalItems}</b> പരിപാടികൾ)</>
                  ) : (
                    <>Showing <b>{indexOfFirstItem + 1}</b> - <b>{Math.min(indexOfLastItem, totalItems)}</b> of <b>{totalItems}</b> Events</>
                  )}
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <button
                    className="btn btn-outline-primary btn-sm px-3 py-2"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                  >
                    <i className="fa fa-chevron-left mr-1"></i> {props.state.language === "ma" ? "മുമ്പത്തെ" : "Prev"}
                  </button>
                  
                  {(() => {
                    const pages = [];
                    const maxVisible = 5;
                    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
                    let end = Math.min(totalPages, start + maxVisible - 1);
                    if (end - start + 1 < maxVisible) {
                      start = Math.max(1, end - maxVisible + 1);
                    }
                    
                    if (start > 1) {
                      pages.push(
                        <button
                          key={1}
                          className={`btn btn-sm px-3 py-2 ${currentPage === 1 ? "btn-primary text-white" : "btn-outline-primary"}`}
                          onClick={() => setCurrentPage(1)}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          1
                        </button>
                      );
                      if (start > 2) {
                        pages.push(<span key="dots-start" className="px-2 align-self-center text-muted">...</span>);
                      }
                    }
                    
                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button
                          key={i}
                          className={`btn btn-sm px-3 py-2 ${currentPage === i ? "btn-primary text-white" : "btn-outline-primary"}`}
                          onClick={() => setCurrentPage(i)}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          {i}
                        </button>
                      );
                    }
                    
                    if (end < totalPages) {
                      if (end < totalPages - 1) {
                        pages.push(<span key="dots-end" className="px-2 align-self-center text-muted">...</span>);
                      }
                      pages.push(
                        <button
                          key={totalPages}
                          className={`btn btn-sm px-3 py-2 ${currentPage === totalPages ? "btn-primary text-white" : "btn-outline-primary"}`}
                          onClick={() => setCurrentPage(totalPages)}
                          style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                        >
                          {totalPages}
                        </button>
                      );
                    }
                    return pages;
                  })()}

                  <button
                    className="btn btn-outline-primary btn-sm px-3 py-2"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                    style={{ borderRadius: "6px", fontWeight: "600", fontSize: "13px" }}
                  >
                    {props.state.language === "ma" ? "അടുത്തത്" : "Next"} <i className="fa fa-chevron-right ml-1"></i>
                  </button>
                </div>
              </div>
            )}
          </div>
          {/* =================================================================================================== */}
        </div>
      </div>
    </>
  );
}
